module.exports = __webpack_public_path__ + "static/img/news3_img.ea076cc.png";